export default function addToReducer(state, action) {
	return (state || []).concat([action.element]);
}
